import type { MetricsReportFilterKey } from '@/admin/common/reportFilters/reportFilterDefaults';

export type DashboardDefinition = {
  id: string;
  metrics: string[];
  /** Filters sent to the API (includes hidden switches). */
  filterNames: MetricsReportFilterKey[];
  titleKey: string;
  subtitleKey: string;
};

/**
 * Creates a typed dashboard definition for useDashboard / DashboardPage.
 */
export function defineDashboard(definition: DashboardDefinition): DashboardDefinition {
  return definition;
}
